import {
  getOrderStatusColor,
  useWLOrgConfigContext,
  type Column,
  type ColumnDef,
  type CustomerOrder,
  type FilledPercentColumnParams,
} from '@talos/kyoko';
import { useMemo } from 'react';

export function useOrderHistoryBlotterColumns() {
  const { config } = useWLOrgConfigContext();

  return useMemo(() => {
    const columns: Column[] = [
      { type: 'orderStatus', field: 'OrdStatus' },
      { type: 'date', field: 'SubmitTime', sortable: true, initialSort: '-' },
      { type: 'account', field: 'MarketAccount' },
      { type: 'security', field: 'Symbol' },
      { type: 'side', field: 'Side' },
      { type: 'size', field: 'OrderQty', params: { currencyField: 'Currency' } },
      {
        type: 'currency',
        field: 'Currency',
        id: 'qtyCurrency',
        initialHide: true,
      },
      {
        type: 'filledPercent',
        id: 'filledPercent',
        params: {
          filledQtyField: 'CumQty',
          totalQtyField: 'OrderQty',
          getColor: (node, theme) => getOrderStatusColor(node.data, true, theme),
          showLabel: false,
        } satisfies FilledPercentColumnParams<CustomerOrder>,
      },
      { type: 'size', field: 'CumQty', params: { currencyField: 'Currency' } },
      {
        type: 'price',
        field: 'Price',
        params: { assetField: 'Symbol', quoteCurrencyField: 'QuoteCurrency' },
      },
      {
        type: 'currency',
        id: 'priceCurrency',
        title: { intlKey: 'priceCurrency' },
        initialHide: true,
        params: {
          symbolField: 'Symbol',
          securityCurrencyField: 'QuoteCurrency',
        },
      },
      {
        type: 'price',
        field: 'AvgPx',
        params: { assetField: 'Symbol', quoteCurrencyField: 'QuoteCurrency' },
      },
      { type: 'size', field: 'CumAmt', title: { intlKey: 'value' }, params: { currencyField: 'AmountCurrency' } },
      { type: 'size', field: 'CumFee', initialHide: true, params: { currencyField: 'FeeCurrency' } },
      { type: 'strategy', field: 'Strategy' },
      { type: 'id', field: 'OrderID' },
      {
        type: 'user',
        field: 'CustomerUser',
        title: { intlKey: 'user' },
        params: {
          valueFormatWithMap: 'email',
          displayValueAs: config.hideUserEmail ? 'displayName' : 'email',
        },
      },
    ] satisfies ColumnDef<CustomerOrder>[];
    return columns;
  }, [config.hideUserEmail]);
}
